import cls from 'classnames'

import type { TrackReference } from '@livekit/components-react'
import type { Participant } from 'livekit-client'
import type { MobileGridLayout } from './mobileGridLayout'

import { OverflowTile } from './OverflowTile'
import { ParticipantTile } from './ParticipantTile'
import styles from './medentee.module.css'

export type MobileGridPageProps = {
  participants: Participant[]
  trackByIdentity: Record<string, TrackReference>
  layout: MobileGridLayout
}

export function MobileGridPage({ participants, trackByIdentity, layout }: MobileGridPageProps) {
  if (!layout.visible) {
    return null
  }

  const shown = participants.slice(0, layout.visible)

  return (
    <div
      className={styles.mobilePage}
      style={{
        gridTemplateColumns: `repeat(${layout.columns}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${layout.rows}, minmax(0, 1fr))`
      }}
    >
      {shown.map((participant, index) => (
        <div
          key={participant.sid}
          className={cls(styles.mobileTile, {
            [styles.mobileTileWide]: layout.isLastFullWidth && index === shown.length - 1
          })}
        >
          <ParticipantTile
            participant={participant}
            track={trackByIdentity[participant.identity]}
          />
        </div>
      ))}

      {layout.overflow > 0 && (
        <div className={styles.mobileTile}>
          <OverflowTile participants={participants.slice(layout.visible)} />
        </div>
      )}
    </div>
  )
}
